export class DropDownModel {

  empty = { itemID: '', id: 0, name: '' };

}

export const dropDownModel = new DropDownModel();
